import { z } from "zod";

export const MetierSchema = z.object({
  id: z.string(),
  nom: z.string().optional(),
  couleur: z.string().optional(),
  actif: z.boolean().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});
export type MetierRow = z.infer<typeof MetierSchema>;

export const MetierUpdateSchema = MetierSchema
  .omit({ id: true, created_at: true, updated_at: true })
  .partial();
export type MetierUpdate = z.infer<typeof MetierUpdateSchema>;
